import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Paper, Typography, Button, Avatar } from '@mui/material';
// import decode from 'jwt-decode'

import useStyles from './styles'

const Nav = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const [retailer, setRetailer] = useState(JSON.parse(localStorage.getItem('retailer')))
    const logout = () => {
        dispatch({ type: 'LOGOUT' })
        history.push('/')
        setRetailer(null)
    }

    useEffect(()=>{
        // const token = retailer?.token
        // if(token){
        //     const decodedToken = decode(token)
        //     if(decodedToken.exp * 1000 < new Date().getTime())
        //         logout()
        // }
        setRetailer(JSON.parse(localStorage.getItem('retailer')))
    }, [location])


    return ( 
        <Paper className={classes.appbar}>
            <Typography component={Link} to='/'>Home</Typography>
            <Typography component={Link} to='/summary'>Summary</Typography>
            {
                retailer ?  (
                    <div className={classes.div}>
                        <Avatar>
                            {retailer?.user?.name.charAt(0)}
                        </Avatar>
                        <Typography style={{margin: '0 2rem 0 1rem'}} variant='h6'>
                            {retailer?.user?.name}
                        </Typography>
                        <Button variant='contained' color='secondary' onClick={logout}>
                        Logout
                    </Button>
                    </div>
                ) : (
                        <Button variant='contained' color='primary' component={Link} to='/auth'>
                            Account
                        </Button>
                )
            }
            
        </Paper>
    );
}
 
export default Nav;